import ribeiraoImg from "../img/unidades/rp.png";
import campinasImg from "../img/unidades/camp.png";
import sjrpImg from "../img/unidades/sjrp.png";

export const CITIES_DATA = {
  ribeirao: {
    id: "ribeirao",
    name: "Ribeirão Preto",
    shortName: "Ribeirão Preto",
    hours: "Seg-Sex: 08:00 → 18:00",
    hoursWeek: "8h às 18h",
    hoursweekend: "9h às 13:00h",

    // endereço
    address: "Av. Pres. Vargas, 474",
    neighborhood: "Jardim Sumare",
    cidade: "Ribeirão Preto",
    state: "SP",
    cep: "14025-405",

    // localização
    lat: -21.192599,
    lng: -47.8098659,

    // serviços
    cpap: true,
    home: true,
    aud: true,

    // telefone (somente números)
    phone: "1634424470",
    whatsappPhone: "1634424470",
    img: ribeiraoImg,
    contactInfo: "Formulário • Contato"
  },

  sjriopreto: {
    id: "sjriopreto",
    name: "S. J. do Rio Preto",
    shortName: "Rio Preto",
    hours: "Seg-Sex: 09:00 → 18:00",
    hoursWeek: "9h às 18h",
    hoursweekend: "",

    // endereço
    address: "R. Gen. Glicério, 5280",
    neighborhood: "Vila São Pedro",
    cidade: "São José do Rio Preto",
    state: "SP",
    cep: "15091-000",

    // localização
    lat: -20.8250178,
    lng: -49.3988009,

    // serviços
    cpap: true,
    home: true,
    aud: false,

    // telefone (somente números)
    phone: "1733633749",
    whatsappPhone: "1634424470",

    img: sjrpImg,
    contactInfo: "WhatsApp • Contato"
  },

  campinas: {
    id: "campinas",
    name: "Campinas",
    shortName: "Campinas",
    hours: "Seg-Sex: 09:00 → 18:00",
    hoursWeek: "9h às 18h",
    hoursweekend: "9h às 13:00h",

    // endereço
    address: "R. Frei Manoel da Ressurreição, 1518",
    neighborhood: "Jardim Guanabara",
    cidade: "Campinas",
    state: "SP",
    cep: "13073-027",

    // localização
    lat: -22.884108,
    lng: -47.0713571,

    // serviços
    cpap: true,
    home: true,
    aud: false,

    // telefone (somente números)
    phone: "1933256912",
    whatsappPhone: "1634424470",

    img: campinasImg,
    contactInfo: "Agende sua Visita"
  }
};
